<template>
  <div class="c-fa-new-step4 header">
    Nomor Handphone
    <div class="c-fa-new-step3-content mb-5">
      Hi, {{ salutation }} {{ name }} , mohon masukkan nomor telepon agar kami dapat menghubungi {{ salutation }}.
      <div class="input-group mt-4">
        <div class="input-group-prepend">
          <div class="input-group-text">+62</div>
        </div>
        <input
          class="form-control p-3"
          id="inlineFormInputGroup"
          :value="phoneNumber"
          maxlength="14"
          placeholder="81xxx xxx xxx"
          @keyup="checkPhoneNumber"
        >
      </div>
      <div v-if="error && errorText != ''" class="form-group col-sm-12 text-error">
        <img src="../../../../../assets/images/svg/ic-warning.svg" style="padding-right: 10px;">
          {{ errorText }}
      </div>
    </div>
    <button  class="button-fixed-1 button-continue" 
      :disabled="error  || phoneNumber == '' || phoneNumber == null " 
      @click="nextStep()"
    >
      LANJUTKAN
    </button>
  </div>
</template>

<script>
export default {
  name: 'Step4',
  data() {
    return {
      phoneNumber: null,
      error: false,
      errorText: ""
    }
  },
  props: {
    phone: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: '',
    },
    salutation: {
      type: String,
      default: '',
    }
  },
  created() {
    this.phoneNumber = this.phone;
  },
  methods: {
    checkPhoneNumber(event) {
      var temp =  event.target.value.replace(/[^0-9\-]/g,'');
      this.phoneNumber  = temp.replace('-','');
      event.target.value = this.phoneNumber;
      if (this.phoneNumber != null && this.phoneNumber.length < 8 ) {
        this.error = true;
        this.errorText = 'Nomor handphone minimal 8 digit'
      } else if (this.phoneNumber == null ) {
        this.error = true;
        this.errorText = 'Nomor handphone harus diisi'
      } else {
        this.error = false;
        this.errorText = ''
      }
    },
    nextStep() {
      this.$emit('submit:phone', this.phoneNumber);
    }
  }
};
</script>